
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ResyncPricePoliciesUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    
  public async handle (
    pricePolicyId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.reSync(pricePolicyId)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
